import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { flowRight as compose } from 'lodash';

import Avatar from '../Avatar';

import UnreadThreadsQuery from '../Message/getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

import icon from '/public/SiteIcons/menuIcon.svg';
import iconTwo from '/public/SiteIcons/menuIconTwo.svg';

import s from './DropDownMenu.css';

function DropDownMenu({ allUnreadThreadsCount, homeHeaderOnly, isVerified }) {
  const layoutType = useSelector(state => state?.siteSettings?.data?.homePageType);

  const { loading, getUnreadCount } = allUnreadThreadsCount || {};
  const count = !loading && getUnreadCount?.total ? getUnreadCount.total : 0;
  const isNewMessage = count > 0;

  return (
    <div className={s.menuBg}>
      {isVerified && isNewMessage && (
        <span className={cx(s.userAvatarNotifyIcon, 'userAvatarNotifyIconRTL')} />
      )}

      {/* {layoutType !== 2 && ( */}
        <span>
          {/* {homeHeaderOnly ? (
            <img src={icon} alt="Menu Icon" className={s.moveTop} />
          ) : ( */}
            <img src={iconTwo} alt="Menu Icon" className={s.moveTop} />
          {/* )} */}
        </span>
      {/* )} */}

      {/* {layoutType === 2 && (
        <span>
          <img src={iconTwo} alt="Menu Icon" className={s.moveTop} />
        </span>
      )} */}

      <span>
        <Avatar
          isUser
          type="small"
          height={32}
          width={32}
          className={s.userAvatar}
        />
      </span>
    </div>
  );
}

DropDownMenu.propTypes = {
  allUnreadThreadsCount: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getUnreadCount: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }),
  }),
  homeHeaderOnly: PropTypes.bool,
  isVerified: PropTypes.bool,
};

DropDownMenu.defaultProps = {
  allUnreadThreadsCount: {
    loading: true,
    getUnreadCount: {
      total: 0,
    },
  },
};

export default compose(
  withStyles(s),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreadsCount',
    options: {
      ssr: false,
    },
  })
)(DropDownMenu);
